import Navbar from "react-bootstrap/Navbar";
import geriact_logo from "../../media/images/geriact_logo2.png";
import { useDispatch, useSelector } from "react-redux";
import { logout } from "../../store/slices/user";
import { useNavigate } from "react-router-dom";
import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import NavDropdown from "react-bootstrap/NavDropdown";
import Button from "react-bootstrap/Button";
import { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import { makeGetRequest } from "../../utils/api";
import { urls } from "../../utils/urls";
import { hasPermission } from "../../utils/permissions";
import { NAVBAR_ID } from "../../utils/layout";

function NavBar(props) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [show, setShow] = useState(false);
  const [logo, setLogo] = useState();
  const [communityName, setCommunityName] = useState();

  // AuthenticationPortal already resolved these; re-fetching them here cost two
  // extra sequential requests on every page load.
  const { resolvedPermissions } = useSelector((state) => state.user);
  const insights = hasPermission(resolvedPermissions, "Insights");
  const plm = hasPermission(resolvedPermissions, "PLM");

  const handleLogout = () => {
    dispatch(logout());
    navigate("/login");
    window.location.reload();
  };

  const UpdateLogo = async () => {
    // Only community subdomains have a logo. Anything without one - localhost,
    // and the bare apex domain - would otherwise fire a request every load with
    // a nonsense value like "localhost:3000/home".
    const labels = window.location.hostname.split('.')
    const subdomain = labels.length > 2 ? labels[0] : null
    if(subdomain && subdomain != 'geriactive'){
      const response = await makeGetRequest(
        urls.communityImage + "?community_subdomain=" + subdomain,
        ""
      );
      if(response.status == 200){
        if(response.data.length > 0){
          setLogo(response.data[0].community_image_url)
          setCommunityName(response.data[0].name)
        }
    }
  }
}
  useEffect(() => {
    if(logo == undefined){
      UpdateLogo()
    }
  },[])

  return (
    <Navbar
      id={NAVBAR_ID}
      expand="lg"
      className="bg-body-tertiary py-0"
      style={{ backgroundColor: "#42e3ffdb" }}
    >
      <Container fluid>
        <Navbar.Brand onClick={() => navigate("/home")} style={{ cursor: "pointer", display: "flex", alignItems: "center", gap: "10px", fontWeight: "bold", fontSize: "1.05rem", padding: 0, marginRight: "12px" }}>
        {logo ? (
          <img src={logo} alt="" style={{ width: "88px", height: "28px" }} />
        ) : (
          <img src={geriact_logo} alt="" style={{ width: "45px", height: "32px" }} />
        )}
        {plm ? (
          <span style={{ display: "flex", flexDirection: "column", lineHeight: 1.15 }}>
            <span>Project Love Meter</span>
            <span style={{ fontSize: "0.7rem", fontWeight: "normal" }}>
              Powered By GeriActive, Partnered with Accushield
            </span>
          </span>
        ) : (
          logo ? communityName : "GeriActive"
        )}
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="me-auto py-1" style={{ fontSize: "1.05rem" }}>
            <Nav.Link onClick={() => navigate("/home")}>Home</Nav.Link>
            {resolvedPermissions && !plm && <Nav.Link onClick={() => navigate("/resource-selector")}>Resources</Nav.Link>}
            {insights && <Nav.Link onClick={() => navigate("/insights")}>Insights</Nav.Link>}
          </Nav>
        </Navbar.Collapse>
        {/*<Button onClick={() => navigate("/help")} style={{ width: "25%" }}>
          Help
        </Button> */}
        <Button
          size="sm"
          style={{ marginLeft: "5px" }}
          variant="danger"
          onClick={() => setShow(true)}
        >
          Logout
        </Button>
      </Container>
      <Modal show={show} onHide={() => setShow(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Confirm</Modal.Title>
        </Modal.Header>
        <Modal.Body>Are you sure that you want to Logout?</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShow(false)}>
            No
          </Button>
          <Button variant="primary" onClick={handleLogout}>
            Yes
          </Button>
        </Modal.Footer>
      </Modal>
    </Navbar>
  );
}

export default NavBar;
